export enum BUTTON_TEXT_POSITIONS {
  LEFT = 'left',
  RIGHT = 'right',
}